import type { IconData } from '@stacksjs/iconify-core'

export const target3Solid: IconData = {
  "body": "<g fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"><path d=\"M38.423 25.5c-.7 6.81-6.113 12.223-12.923 12.923V36a1.5 1.5 0 0 0-3 0v2.423c-6.81-.7-12.223-6.113-12.923-12.923H12a1.5 1.5 0 0 0 0-3H9.577c.7-6.81 6.113-12.223 12.923-12.923V12a1.5 1.5 0 0 0 3 0V9.577c6.81.7 12.223 6.113 12.923 12.923H36a1.5 1.5 0 0 0 0 3zM19.5 24a1.5 1.5 0 0 0 1.5 1.5h1.5V27a1.5 1.5 0 0 0 3 0v-1.5H27a1.5 1.5 0 0 0 0-3h-1.5V21a1.5 1.5 0 0 0-3 0v1.5H21a1.5 1.5 0 0 0-1.5 1.5\"/><path d=\"M24 46.5C11.574 46.5 1.5 36.426 1.5 24S11.574 1.5 24 1.5S46.5 11.574 46.5 24S36.426 46.5 24 46.5M6.5 24c0 9.665 7.835 17.5 17.5 17.5S41.5 33.665 41.5 24S33.665 6.5 24 6.5S6.5 14.335 6.5 24\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default target3Solid
